<!-- 新闻列表 -->
<template>
    <transition name="el-fade-in-linear">
        <div id="self-con">
            <headerVue></headerVue>
            <section v-loading="isLoading">
                <div class="member-demeanour" v-if="$route.query.name === '社员风采'">
                    <div v-for="self in selfConList" :key="self.id" v-show="self.navName !== '社员动态'"
                        @click="$router.push(`/newsList?tm=${self.id}&navName=${self.navName}&stitle=${self.navName}`)">
                        {{ self.navName }}
                    </div>
                </div>
                <!-- <div class="citylist">
                    <div class="citybox" :style="{ width: 100 / selfConList.length + '%' }"
                        :class="{ active: currentNav == item.id }" v-for="(item, index) in selfConList"
                        @click="toItemList(item.id)" :index="index.toString()" :key="item.id">
                        {{ item.navName }}
                    </div>
                </div> -->
                <!-- 右侧 -->
                <!-- :style="{ width: $route.query.navName === '自身建设' ? '32%' : '100%' }" -->
                <template v-if="$route.query.name !== '自身建设'">
                    <div class="self-card" style="width:100%" v-for="self in selfConList" :key="self.id"
                        v-show="!($route.query.name === '社员风采' && self.navName !== '社员动态')">
                        <div class="card-header">
                            <h3>{{ self.navName }}</h3>
                            <p @click="$router.push(`/selfConstructionList?tm=${self.id}&navName=${self.navName}`)">更多></p>
                        </div>
                        <ul class="news-list" v-if="childrenList[self.id] && childrenList[self.id].length">
                            <li v-for="mes in childrenList[self.id]" :key="mes.id"
                                @click="$router.push(`/newsDetail?tm=${mes.id}`)" v-show="!self.children.length">
                                <div><i class="el-icon-caret-top"></i>{{ mes.title }}</div>
                                <div v-if="$route.query.name !== '自身建设'" style="font-size: 14px;color: #999999;">{{
                                    mes.releaseTime }}</div>
                            </li>
                        </ul>
                        <div v-if="childrenList[self.id] && childrenList[self.id].length == 0">
                            <p style="
                                color: #ccc;
                                text-align: center;
                                line-height: 230px;
                                font-size: 28px;
                            ">
                                暂无数据
                            </p>
                        </div>
                    </div>
                </template>
                <div class="self-card" style="width: 100%" v-for="self in dataConList" :key="self.id"
                    v-show="$route.query.name === '自身建设'">
                    <div class="children-card">
                        <!-- <div style="display: flex;align-items: center;justify-content: center;border-bottom: 2px solid #0b7dda;">
                            <h3 style="width: 100px;">{{ self.navName }}</h3>
                        </div> -->
                        <div style="display: flex;justify-content:flex-start;margin-top:20px;flex-wrap: wrap;">
                            <div v-for="subItem in self.children" :key="subItem.id" style="width: 32%;margin-left: 1%;"
                                class="isMobile">
                                <div class="card-header">
                                    <h3>{{ subItem.navName }}</h3>
                                    <p
                                        @click="$router.push(`/selfConstructionList?tm=${subItem.id}&navName=${subItem.navName}`)">
                                        更多></p>
                                </div>

                                <ul class="news-list"
                                    v-if="dataConChildrenList[subItem.id] && dataConChildrenList[subItem.id].length">
                                    <li v-for="mes in dataConChildrenList[subItem.id]" :key="mes.id"
                                        @click="$router.push(`/newsDetail?tm=${mes.id}`)">
                                        <div><i class="el-icon-caret-top"></i>{{ mes.title }}</div>
                                    </li>
                                </ul>
                                <div v-if="dataConChildrenList[subItem.id] && dataConChildrenList[subItem.id].length == 0">
                                    <p style="
                                        color: #ccc;
                                        text-align: center;
                                        line-height: 230px;
                                        font-size: 28px;
                                    ">
                                        暂无数据
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <footerVue></footerVue>
        </div>
    </transition>
</template>
  
<script>
import headerVue from "../index/header.vue";
import footerVue from "../foot/foot.vue";
import { isMobile } from "@/utils/common.js";
export default {
    name: "selfConList",
    components: {
        headerVue,
        footerVue
    },
    data() {
        return {
            selfConList: [],
            fontSize: "18px",
            childrenList: {},
            dataConList: [],
            dataConChildrenList: {},
            isLoading: true
        };
    },
    mounted() {
        this.getNavList();
    },
    watch: {
        $route() {
            // console.log('this.$route.query.name', this.$route.query.name, this.currentNavId);
            this.selfConList = [];
            this.dataConList = [],
                this.childrenList = {}
            this.dataConChildrenList = {}
            this.getNavList();
        }
    },
    methods: {
        async getNavList() {
            const { data, status } = await this.$api.nav.getNavList(
                1,
                this.$route.query.tm
            );
            if (status !== 200) return;
            let arr = this.$route.query.isSingle === 'true' ? data.data.filter(i => i.navName === this.$route.query.navName) : data.data
            arr.forEach(async item => {
                if (this.$route.query.name !== '自身建设') this.selfConList.push(item);
                else this.dataConList.push(item)
                await this.getArticle(item);
            });
        },
        async getArticle(item) {
            if (this.$route.query.name === '自身建设') {
                item.children.forEach(async self => {
                    await this.selfGetArticle(self.id);
                });
            } else {
                const { data, status } = await this.$api.nav.getArticle(item.id, 1, 6, 1);
                if (status !== 200) return;
                this.$set(this.childrenList, String(item.id), data.rows)
                this.isLoading = false
            }
        },
        async selfGetArticle(id) {
            const { data, status } = await this.$api.nav.getArticle(id, 1, 6, 1);
            if (status !== 200) return;
            this.$set(this.dataConChildrenList, id, data.rows)
            this.isLoading = false
        }
    }
};
</script>

<style lang="scss" scoped>
#self-con {
    section {
        display: flex;
        justify-content: space-between;
        width: 1200px;
        margin: 0 auto;
        flex-wrap: wrap;

        .member-demeanour {
            width: 100%;
            display: flex;
            align-items: flex-start;
            justify-content: space-around;

            &:hover {
                cursor: pointer;
            }

            >div {
                height: 60px;
                background-color: #0b7dda;
                width: 180px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 10px 0;
                color: #fff;
                font-weight: bold;
            }
        }

        .self-card {
            width: 32%;
            box-sizing: border-box;
            margin-top: 20px;
            margin: 0 auto;
            margin-top: 20px;
            margin-bottom: 20px;

            .children-card {
                // display: flex;
                // align-items: center;
                // justify-content: space-between;
                // border-bottom: 2px solid #0b7dda;
                // padding-right: 10px;
            }

            .card-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 2px solid #0b7dda;
                padding-right: 10px;

                p {
                    line-height: 50px;
                    color: #1e74cd;
                    cursor: pointer;
                }
            }

            h3 {
                border-radius: 10px 0 0;
                background-color: #0b7dda;
                color: white;
                font-size: 22px;
                height: 50px;
                line-height: 50px;
                position: relative;
                padding: 0 12px;
            }

            .news-list {
                >li {
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    -o-text-overflow: ellipsis;
                    line-height: 46px;
                    margin-top: 20px;
                    margin-bottom: 10px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;


                    >div:first-child {
                        flex: 1;
                        width: calc(100% - 100px);
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        -o-text-overflow: ellipsis;

                        >i {
                            transform: rotate(90deg);
                        }
                    }

                    >div:last-child {
                        width: 100px;
                    }
                }
            }
        }
    }

    .citylist {
        display: none;
    }

    @media screen and (max-width: 768px) {
        .self-card h3 {
            border-radius:0px !important;
        }
        .citylist {
            display: block;
            flex-wrap: wrap;
            display: flex;
            padding: 10px 10px 0 10px;

            .citybox {
                border: 1px solid #0b7dda;
                box-sizing: border-box;
                text-align: center;
                line-height: 30px;
                font-size: 14px;

                &:nth-child(n + 2) {
                    border-left: none;
                }

                &.active {
                    background: #0b7dda;
                    color: white;
                }
            }
        }

        .isMobile {
            width: 100% !important;
        }

        section {
            width: 100% !important;
        }

        .self-card {
            width: 100% !important;
        }

        .member-demeanour {
            >div {
                transform: scale(0.8)
            }
        }

        .card-header {
            h3 {
                font-size: 17px !important;
                height: 40px !important;
                line-height: 40px !important;
            }

            p {
                font-size: 15px !important;
                height: 40px !important;
                line-height: 40px !important;
            }
        }
    }
}
</style>
  